import { Pipe, PipeTransform } from "@angular/core";
import { Currency } from "@models/interfaces/currency";
import { Fiat } from "@models";
import { FiatService } from "@main-services/currency/fiat.service";
import { TradableListService } from "@main-services/currency/tradable_list.service";
import { Service } from "@main-services/base-service";
import { Tradable } from "@models/interfaces/tradable";

abstract class CurrencyNamePipe<C extends Currency> {
	public constructor(protected walletService: Service<C>) {}

	public transform(id: string): string {
		const currency = this.walletService.getItemById(id);
		if (!currency) {
			return "";
		}
		return currency.getName();
	}
}

@Pipe({
	name: "tradable_name",
	standalone: false
})
export class TradableNamePipe extends CurrencyNamePipe<Tradable> implements PipeTransform {
	public constructor(private tradableListService: TradableListService) {
		super(tradableListService);
	}
}

@Pipe({
	name: "fiat_name",
	standalone: false
})
export class FiatNamePipe extends CurrencyNamePipe<Fiat> implements PipeTransform {
	public constructor(private fiatService: FiatService) {
		super(fiatService);
	}
}
